<template>
  <el-form-item
    :label-width="$attrs['label-width']"
    :prop="$attrs['prop']"
    :label="$attrs['label']"
  >
    <el-checkbox-group
      v-model="labelResult"
      :disabled="disabled"
      :class="customClass"
      @change="handleCheckChange"
    >
      <el-checkbox
        v-for="(item, index) in labelList"
        :key="index"
        :label="item"
        :class="labelClass"
      ></el-checkbox>
    </el-checkbox-group>
  </el-form-item>
</template>

<script>
  import mixins from '@/utils/mixForm'
  export default {
    name: 'VabCheckboxGroup',
    mixins: [mixins],
    inject: {
      pageComponent: {
        default: '',
      },
    },
    data() {
      return {
        labelList: [],
        labelResult: [],
        labelMap: {},
        valueMap: {},
      }
    },
    created() {
      this.type = 'array'
      this.fetchData()
      this.$baseEventBus.$on('ComponentReset', () => {
        this.labelResult = []
        this.setModel(null)
      })
    },
    methods: {
      //チェックボックスの変更イベント
      handleCheckChange(val) {
        this.setModel(val.map((item) => this.labelMap[item]))
      },

      setValue(val) {
        if (val) {
          this.labelResult = val.map((item) => this.valueMap[item])
        }
      },
    },
  }
</script>
